import { useEffect, useState } from 'react'

import { isIosDevice, isStandalone } from '../lib/platform'

const DISMISS_STORAGE_KEY = 'iosInstallPromptDismissed'

function isDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/**
 * iOS の「ホーム画面に追加」案内を表示すべきかどうかと、閉じる操作のハンドラを返す。
 * 案内は iOS Safari で、インストール済み(standalone)PWA として起動していない場合のみ
 * 表示する。閉じた状態は localStorage に永続化する。
 */
export function useIosInstallPrompt() {
  const [shouldShow, setShouldShow] = useState(false)

  useEffect(() => {
    if (isIosDevice() && !isStandalone() && !isDismissed()) {
      setShouldShow(true)
    }
  }, [])

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_STORAGE_KEY, '1')
    } catch {
      // ストレージへの保存失敗（プライベートモード等）は無視し、このセッション中だけ非表示にする。
    }
    setShouldShow(false)
  }

  return { shouldShow, dismiss }
}
